import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import intersectMeshes from "./intersectMeshes";
import subtractMeshes from "./subtractMeshes";

const addBorder = async (_model, plot) => {

    let model = _model;

    let backGroup = new THREE.Group();
    let frontGroup = new THREE.Group();
    let leftGroup = new THREE.Group();
    let rightGroup = new THREE.Group();
    let finalGroup = new THREE.Group();
    const dopusk = 0.02;

    let bboxModel = getPosInfo(model);

    const xSize = plot.xSize + bboxModel.zSize * 2;
    const zSize = plot.zSize + bboxModel.zSize * 2;

    //узнаем количество элементов в задней и передней сторонах
    const countInWidth = xSize / bboxModel.xSize;
    const countInWidthInt = Math.trunc(countInWidth);
    const countInWidthFract = countInWidth - countInWidthInt;

    const countInLength = zSize / bboxModel.xSize;
    const countInLengthInt = Math.trunc(countInLength);
    const countInLengthFract = countInLength - countInLengthInt;

    const sizeLastElementX = (xSize - bboxModel.xSize * countInWidthInt);


    model.position.set(
        plot.bbox.min.x + bboxModel.xSize / 2 - bboxModel.zSize,
        0,
        plot.bbox.min.z - bboxModel.zSize / 2
    );
    model.updateMatrix()
    bboxModel = getPosInfo(model);

    //режем под 45градусов
    const cutMesh = new THREE.Mesh(
        new THREE.BoxGeometry(
            bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
        ),
        new THREE.MeshStandardMaterial()
    )
    cutMesh.position.copy(model.position);
    cutMesh.position.x = bboxModel.bbox.min.x - bboxModel.zSize / 4;
    cutMesh.updateMatrix();
    cutMesh.rotation.y = -Math.PI / 4
    cutMesh.updateMatrix();
    let startModel1 = await subtractMeshes(model, cutMesh, true)

    // backGroup.add(cutMesh);
    //Создаем заднюю сторону
    backGroup.add(startModel1);



    if (parseFloat(countInWidthFract) > dopusk) {
        for (let index = 2; index <= countInWidthInt; index++) {
            const newModel = model.clone();
            newModel.position.x += (index - 1) * bboxModel.xSize;
            backGroup.add(newModel);
        }
    } else {
        for (let index = 2; index < countInWidthInt; index++) {
            const newModel = model.clone();
            newModel.position.x += (index - 1) * bboxModel.xSize;
            backGroup.add(newModel);
        }
        let lastModelInLine = model.clone();
        lastModelInLine.position.x += (countInWidthInt - 1) * bboxModel.xSize;
        lastModelInLine.updateMatrix();
        const bboxNewModel = getPosInfo(lastModelInLine);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxNewModel.xSize, bboxNewModel.ySize, bboxNewModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(lastModelInLine.position);
        cutMeshAngle.position.x = bboxNewModel.bbox.max.x + bboxNewModel.zSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = Math.PI / 4
        cutMeshAngle.updateMatrix();
        lastModelInLine = await subtractMeshes(lastModelInLine, cutMeshAngle, true)
        backGroup.add(lastModelInLine)
    }

    if (parseFloat(countInWidthFract) > dopusk) {
        const newModel = model.clone();
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.updateMatrix();
        const bboxNewModel = getPosInfo(newModel);
        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                sizeLastElementX, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);
        cutMesh.position.x = bboxNewModel.bbox.min.x + sizeLastElementX / 2
        cutMesh.updateMatrix()
        const bboxCutMesh = getPosInfo(cutMesh);

        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(cutMesh.position)

        cutMeshAngle.position.x = bboxCutMesh.bbox.max.x + bboxCutMesh.zSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = Math.PI / 4
        cutMeshAngle.updateMatrix();
        const finishCutMesh = await subtractMeshes(cutMesh, cutMeshAngle, true)
        const cutedModel = await intersectMeshes(newModel, finishCutMesh, true)
        backGroup.add(cutedModel)
    }

    //Создаем переднюю группу
    const fModel = model.clone();
    fModel.position.set(
        plot.bbox.min.x + bboxModel.xSize / 2 - bboxModel.zSize,
        0,
        plot.bbox.max.z + bboxModel.zSize / 2
    );
    fModel.rotation.y = Math.PI;
    fModel.updateMatrix();

    bboxModel = getPosInfo(fModel);

    //режем под 45градусов
    const cutMesh2 = new THREE.Mesh(
        new THREE.BoxGeometry(
            bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
        ),
        new THREE.MeshStandardMaterial()
    )
    cutMesh2.position.copy(fModel.position);
    cutMesh2.position.x = bboxModel.bbox.min.x - bboxModel.zSize / 4;
    cutMesh2.updateMatrix();
    cutMesh2.rotation.y = Math.PI / 4
    cutMesh2.updateMatrix();

    let startModel2 = await subtractMeshes(fModel, cutMesh2, true)
    frontGroup.add(startModel2);

    if (parseFloat(countInWidthFract) > dopusk) {
        for (let index = 2; index <= countInWidthInt; index++) {
            const newModel = fModel.clone();
            newModel.position.x += (index - 1) * bboxModel.xSize;
            frontGroup.add(newModel);
        }
    } else {
        for (let index = 2; index < countInWidthInt; index++) {
            const newModel = fModel.clone();
            newModel.position.x += (index - 1) * bboxModel.xSize;
            frontGroup.add(newModel);
        }
        let lastModelInLine = fModel.clone();
        lastModelInLine.position.x += (countInWidthInt - 1) * bboxModel.xSize;
        lastModelInLine.updateMatrix();
        const bboxNewModel = getPosInfo(lastModelInLine);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxNewModel.xSize, bboxNewModel.ySize, bboxNewModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(lastModelInLine.position);
        cutMeshAngle.position.x = bboxNewModel.bbox.max.x + bboxNewModel.zSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = -Math.PI / 4
        cutMeshAngle.updateMatrix();
        lastModelInLine = await subtractMeshes(lastModelInLine, cutMeshAngle, true)
        frontGroup.add(lastModelInLine)
    }

    if (parseFloat(countInWidthFract) > dopusk) {
        const newModel = fModel.clone();
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.updateMatrix();

        const bboxNewModel = getPosInfo(newModel);

        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                sizeLastElementX, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);
        cutMesh.position.x = bboxNewModel.bbox.min.x + sizeLastElementX / 2
        cutMesh.updateMatrix()
        const bboxCutMesh = getPosInfo(cutMesh);

        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(cutMesh.position)

        cutMeshAngle.position.x = bboxCutMesh.bbox.max.x + bboxCutMesh.zSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = -Math.PI / 4
        cutMeshAngle.updateMatrix();

        const finishCutMesh = await subtractMeshes(cutMesh, cutMeshAngle, true)

        const cutedModel = await intersectMeshes(newModel, finishCutMesh, true)

        frontGroup.add(cutedModel);


    }


    //создаем левую часть бардюра
    const lModel = model.clone();
    lModel.rotation.y = Math.PI / 2;
    lModel.updateMatrix()
    bboxModel = getPosInfo(lModel);

    const sizeLastElementZ = ((plot.zSize + bboxModel.xSize * 2) - bboxModel.zSize * countInLengthInt);

    lModel.position.set(
        plot.bbox.min.x - bboxModel.xSize / 2,
        0,
        plot.bbox.min.z + bboxModel.zSize / 2 - bboxModel.xSize
    );
    lModel.updateMatrix();
    bboxModel = getPosInfo(lModel);

    //режем под 45градусов
    const cutMesh3 = new THREE.Mesh(
        new THREE.BoxGeometry(
            bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
        ),
        new THREE.MeshStandardMaterial()
    )
    cutMesh3.position.copy(lModel.position);
    cutMesh3.position.z = bboxModel.bbox.min.z - bboxModel.xSize / 4;
    cutMesh3.updateMatrix();
    cutMesh3.rotation.y = Math.PI / 4
    cutMesh3.updateMatrix();

    let startModel3 = await subtractMeshes(lModel, cutMesh3, true)

    leftGroup.add(startModel3);

    if (parseFloat(countInLengthFract) > dopusk) {
        for (let index = 2; index <= countInLengthInt; index++) {
            const newModel = lModel.clone();
            newModel.position.z += (index - 1) * bboxModel.zSize;
            leftGroup.add(newModel);
        }
    } else {
        for (let index = 2; index < countInLengthInt; index++) {
            const newModel = lModel.clone();
            newModel.position.z += (index - 1) * bboxModel.zSize;
            leftGroup.add(newModel);
        }
        let lastModelInLine = lModel.clone();
        lastModelInLine.position.z += (countInLengthInt - 1) * bboxModel.zSize;
        lastModelInLine.updateMatrix();
        const bboxNewModel = getPosInfo(lastModelInLine);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxNewModel.xSize, bboxNewModel.ySize, bboxNewModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(lastModelInLine.position);
        cutMeshAngle.position.z = bboxNewModel.bbox.max.z + bboxNewModel.xSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = -Math.PI / 4
        cutMeshAngle.updateMatrix();
        lastModelInLine = await subtractMeshes(lastModelInLine, cutMeshAngle, true)
        leftGroup.add(lastModelInLine)
    }


    if (parseFloat(countInLengthFract) > dopusk) {
        const newModel = lModel.clone();
        newModel.position.z += countInLengthInt * bboxModel.zSize;
        newModel.updateMatrix();

        const bboxNewModel = getPosInfo(newModel);

        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, sizeLastElementZ
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);

        cutMesh.position.z = bboxNewModel.bbox.min.z + sizeLastElementZ / 2
        cutMesh.updateMatrix()

        const bboxCutMesh = getPosInfo(cutMesh);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(cutMesh.position);
        cutMeshAngle.position.z = bboxCutMesh.bbox.max.z + bboxModel.xSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = -Math.PI / 4
        cutMeshAngle.updateMatrix();

        const finishCutMesh = await subtractMeshes(cutMesh, cutMeshAngle, true)

        const cutedModel = await intersectMeshes(newModel, finishCutMesh, true)
        leftGroup.add(cutedModel);

    }


    const rModel = model.clone();
    rModel.rotation.y = -Math.PI / 2;
    rModel.updateMatrix()
    bboxModel = getPosInfo(rModel);
    rModel.position.set(
        plot.bbox.max.x + bboxModel.xSize / 2,
        0,
        plot.bbox.min.z + bboxModel.zSize / 2 - bboxModel.xSize
    );
    rModel.updateMatrix()
    bboxModel = getPosInfo(rModel);

    //режем под 45градусов
    const cutMesh4 = new THREE.Mesh(
        new THREE.BoxGeometry(
            bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
        ),
        new THREE.MeshStandardMaterial()
    )
    cutMesh4.position.copy(rModel.position);
    cutMesh4.position.z = bboxModel.bbox.min.z - bboxModel.xSize / 4;
    cutMesh4.updateMatrix();
    cutMesh4.rotation.y = -Math.PI / 4
    cutMesh4.updateMatrix();

    let startModel4 = await subtractMeshes(rModel, cutMesh4, true)
    rightGroup.add(startModel4);
    if (parseFloat(countInLengthFract) > dopusk) {
        for (let index = 2; index <= countInLengthInt; index++) {
            const newModel = rModel.clone();
            newModel.position.z += (index - 1) * bboxModel.zSize;
            rightGroup.add(newModel);
        }
    } else {
        for (let index = 2; index < countInLengthInt; index++) {
            const newModel = rModel.clone();
            newModel.position.z += (index - 1) * bboxModel.zSize;
            rightGroup.add(newModel);
        }
        let lastModelInLine = rModel.clone();
        lastModelInLine.position.z += (countInLengthInt - 1) * bboxModel.zSize;
        lastModelInLine.updateMatrix();
        const bboxNewModel = getPosInfo(lastModelInLine);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxNewModel.xSize, bboxNewModel.ySize, bboxNewModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(lastModelInLine.position);
        cutMeshAngle.position.z = bboxNewModel.bbox.max.z + bboxNewModel.xSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = Math.PI / 4
        cutMeshAngle.updateMatrix();
        lastModelInLine = await subtractMeshes(lastModelInLine, cutMeshAngle, true)
        rightGroup.add(lastModelInLine)
    }

    if (parseFloat(countInLengthFract) > dopusk) {
        const newModel = rModel.clone();
        newModel.position.z += countInLengthInt * bboxModel.zSize;

        newModel.updateMatrix();

        const bboxNewModel = getPosInfo(newModel);

        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, sizeLastElementZ
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);

        cutMesh.position.z = bboxNewModel.bbox.min.z + sizeLastElementZ / 2
        cutMesh.updateMatrix()

        const bboxCutMesh = getPosInfo(cutMesh);
        const cutMeshAngle = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        );
        cutMeshAngle.position.copy(cutMesh.position);
        cutMeshAngle.position.z = bboxCutMesh.bbox.max.z + bboxModel.xSize / 4;
        cutMeshAngle.updateMatrix();
        cutMeshAngle.rotation.y = Math.PI / 4
        cutMeshAngle.updateMatrix();

        const finishCutMesh = await subtractMeshes(cutMesh, cutMeshAngle, true)

        const cutedModel = await intersectMeshes(newModel, finishCutMesh, true)

        rightGroup.add(cutedModel);
    }

    finalGroup.add(leftGroup);
    finalGroup.add(rightGroup);
    finalGroup.add(backGroup);
    finalGroup.add(frontGroup);

    return finalGroup;

}
export default addBorder;
